class RequestMsg {
  ID: number;
  RequestObj: any;
  UserID: string;
  CompanyID: number;
  PageIndex: number;
  PageSize: number;

  RequestMsg() {
    this.ID = -1;
    this.RequestObj = "";
    this.UserID = "";
    this.CompanyID = -1;
    this.PageIndex = -1;
    this.PageSize = -1;
  }
}

export default RequestMsg;
